import type { Theme } from '../../types/theme'

export const resolveThemeBaseColor = ({
  backgroundStyle,
  theme,
}: {
  backgroundStyle?: string
  theme: Theme
}) => {
  switch (backgroundStyle) {
    case 'solid_beige':
      return {
        base: theme.colors['AB - Surface/Background AB - Same'],
        secondary: theme.colors['AB - Surface/Background AB - Same'],
      }

    case 'solid_theme':
      return {
        base: theme.colors['AB - Surface/Background AB - Theme'],
        secondary: theme.colors['AB - Surface/Background AB - Theme'],
      }
    case 'theme_gradient':
      return {
        base: theme.colors['AB - Surface/BG Gradient colour 01'],
        secondary: theme.colors['AB - Surface/BG Gradient colour 02'],
      }
    case 'base':
    default:
      return {
        base: theme.colors['N Surface/Base'],
        secondary: theme.colors['N Surface/Base'],
      }
  }
}
